import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { CultureMapService, type UnpaginatedCultureFacilityListResponse } from '@ui/shared/util-api';
import { CultureMapItemModel } from '../../entities/culture-map-item.model';
import type { CultureMapFilter } from '../../types/culture-map-filters';
import { CulturalFacilityMapper } from '../../mappers/cultural-facility-mapper';
import { CulturalKindMapper } from '../../mappers/cultural-kind-mapper';

@Injectable({ providedIn: 'root' })
export class FacilityMapDataService extends MapDataService<CultureMapItemModel, CultureMapFilter> {
    protected _api = inject(CultureMapService);

    public getData$({
                        search,
                        ageGroups,
                        experienceType,
                        categories,
                        kind,
                    }: CultureMapFilter): Observable<Array<CultureMapItemModel>> {
        if (ageGroups || categories || experienceType || !CulturalKindMapper.isFilterFacility(kind as string)) {
            return of([]);
        }

        return this._api.getAllCultureFacilities({
            nameContains: search as string,
        }).pipe(map(offerings => this._mapFacilitiesToMapItems(offerings)));
    }

    protected _mapFacilitiesToMapItems(listResponse: UnpaginatedCultureFacilityListResponse): Array<CultureMapItemModel> {
        return listResponse.data.map(facility => CulturalFacilityMapper.fromDto(facility));
    }
}
